import { useCallback, useState } from 'react';
import { IRegionShort } from '@/api/region/types';
import { NextLink } from '@/components/blocks/NextLink';
import { SearchPopup } from '@/components/home/SearchPopup';
import { Routes } from '@/routes';
import { useAnalytics } from '@/tracking/analytics';

// Tile in the popular-searches grid. Hover reveals the primary-blue text
// over a fully opaque white surface (vs. the resting 85% opacity).
const cellClass = [
  'group flex min-h-[50px] items-center justify-center cursor-pointer',
  'bg-white opacity-[0.85] border-0 appearance-none',
  'hover:opacity-100',
  'max-md:basis-[49%] max-md:min-h-[45px]',
].join(' ');

const queryClass = [
  'flex items-center justify-center h-[50px] min-w-[50px]',
  'text-sm leading-[1.275rem] font-normal text-[#304769] opacity-90',
  'group-hover:text-primary group-hover:font-semibold',
].join(' ');

export const Cell = ({ query }: { query: string | IRegionShort }) => {
  const [isSearchOpen, setSearchOpen] = useState<boolean>(false);
  const a = useAnalytics();

  const toggleSearch = useCallback(() => {
    setSearchOpen(!isSearchOpen);
    if (!isSearchOpen) { // Will be open
      a.searchBox();
    }
  }, [isSearchOpen]);

  if (typeof query === 'string') {
    return (
      <>
        {isSearchOpen && (
          <SearchPopup
            closePopup={toggleSearch}
            query={query}
          />
        )}
        <button
          type="button"
          className={cellClass}
          onClick={toggleSearch}
        >
          <div className={queryClass}>{query}</div>
        </button>
      </>
    );
  }
  return (
    <NextLink
      href={Routes.regionSnowReport(query)}
      type="button"
      className={cellClass}
    >
      <div className={queryClass}>{query.title}</div>
    </NextLink>
  );
};
